import Link from "@/components/common/Link";
import { OpenType, getSoftMgrVersion } from "@q/softCore";
import classnames from "classnames";
import React, { useState, useEffect } from "react";
import { GAME, GAME_AREA } from "@/common/url";
import "./index.scss";
import { cloneDeep } from "lodash-es";

export const NAV_DATA = [
  {
    key: "index",
    name: "精选",
    href: GAME,
  },
  {
    key: "web",
    name: "页游",
    href: `${GAME_AREA}?type=web`,
  },
  {
    key: "cloud",
    name: "云游戏",
    href: `${GAME_AREA}?type=cloud`,
  },
  {
    key: "external",
    name: "小游戏",
    href: `${GAME_AREA}?type=external`,
  },
];

interface IProps {
  current: "index" | "web" | "cloud" | "external";
}

const Nav: React.SFC<IProps> = ({ current }) => {
  const [navData, setNavData] = useState(NAV_DATA);

  useEffect(() => {
    const getNewNavData = (ver: string) => {
      const cloneNavData = cloneDeep(NAV_DATA);
      cloneNavData[0].href = `${NAV_DATA[0].href}?ver=${ver}`;
      setNavData(cloneNavData);
    };
    try {
      // 游戏精选链接需带上版本号
      getSoftMgrVersion().then((ver) => {
        getNewNavData(ver);
      });
    } catch {
      const ver = "7.5.1";
      getNewNavData(ver);
    }
  }, []);

  return (
    <nav className="nav clearfix" data-bk="导航">
      {navData.map(({ key, name, href }) => {
        return (
          <Link
            key={key}
            className={classnames("nav__item", { current: key === current })}
            href={href}
            openType={OpenType.openWithClient}
            foraword={href}
          >
            {name}
          </Link>
        );
      })}
    </nav>
  );
};

export default Nav;
